import { DICTIONARY } from 'Enum';
import { Dictionary } from 'Dictionary';
import { CustomMetaTitle, LinkReturnToMain } from 'Components';
import { DocumentsMain } from './DocumentsMain';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Stack } from '@mui/material';

export const Documents = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  return (
    <>
      <CustomMetaTitle title={dictionary.title} />
      <LinkReturnToMain />
      <Stack marginTop={isDesktop ? '54px' : '24px'} marginBottom={'88px'}>
        <DocumentsMain />
      </Stack>
    </>
  );
};
